export default function ContactSection() {
  return (
    <section className="relative w-full py-20 md:py-28 px-6 md:px-10 bg-background-950">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <p className="text-sm tracking-[0.25em] uppercase text-background-400 font-label font-medium mb-4">Get in Touch</p>
          <h2 className="font-heading text-3xl md:text-4xl font-medium text-background-50">
            Contact
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
          <div className="space-y-6">
            <div>
              <p className="text-xs tracking-[0.2em] uppercase text-background-300 font-label mb-2">Address</p>
              <p className="text-base text-background-100 leading-relaxed font-light">
                12-14 Kennedy<br />
                Nicosia, 1087<br />
                Cyprus
              </p>
            </div>
          </div>
          <div className="space-y-6">
            <div>
              <p className="text-xs tracking-[0.2em] uppercase text-background-300 font-label mb-2">Phone</p>
              <p className="text-base text-background-100 font-light">
                +357 96143236
              </p>
            </div>
            <div>
              <p className="text-xs tracking-[0.2em] uppercase text-background-300 font-label mb-2">Email</p>
              <p className="text-base text-background-100 font-light">
                contact@berengor.com
              </p>
            </div>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-background-700/50">
          <p className="text-xs text-background-400 font-light">
            &copy; {new Date().getFullYear()} BERENGOR LIMITED. All rights reserved.
          </p>
        </div>
      </div>
    </section>
  );
}